export const MAINTENANCE_PACKAGE_UK = 'Maintenance Package (UK only)'
export const INSPECTION_INTERVAL_UK = 'S&M Inspection Interval (UK only)'
export const DMSC_OPTION_LIST = 'List'
export const DMSC_OPTION_DOUBLE = 'Double'
export const JOB_EXECUTED_EVENT = 'jobExecuted'
export const MAINTENANCE_PLAN_REQUEST_EVENT = 'maintenancePlanRequest'
